import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import Iconify from 'src/components/iconify';

import { RecordAction } from './record-panel.types';

// ----------------------------------------------------------------------

/**
 * Shared record-panel action row (JT1-1529). Every action is a labelled button in the same style —
 * no lone icons among labelled buttons (spec item 13). Hidden actions are dropped; the row collapses
 * to nothing when none remain.
 */
export default function RecordActionBar({ actions }: { actions: RecordAction[] }) {
  const visible = actions.filter((a) => !a.hidden);
  if (!visible.length) return null;

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ px: 2.5, py: 1.5, flexWrap: 'wrap', gap: 1, borderTop: (theme) => `1px solid ${theme.palette.divider}` }}
    >
      {visible.map((action) => (
        <Button
          key={action.key}
          size="small"
          variant="soft"
          color={action.color ?? 'inherit'}
          disabled={action.disabled}
          startIcon={<Iconify icon={action.icon} />}
          onClick={action.onClick}
        >
          {action.label}
        </Button>
      ))}
    </Stack>
  );
}
